import { SkillType } from './skilltype';
import { DocumentResponse } from './documentresponse';

export class SkillDocWrapper {
    public skillType: SkillType = new SkillType();
    public documentList: DocumentResponse[] = [];
}
